import { getIsVenue } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { memo, useMemo } from 'react';
import ButtonComp, {
  ToggleEnquiryFormButtonCompProps,
} from '@bridebook/web/app-shared/components/supplier/toggle-enquiry-form-button/toggle-enquiry-form-button';
import ToggleEnquiryFormWithSignup from './toggle-enquiry-form-with-signup';

interface IProps
  extends Pick<
    ToggleEnquiryFormButtonCompProps,
    'fixedWidth' | 'styleButton' | 'styleWrapper' | 'noIcon' | 'size'
  > {
  contactMethod: string;
}

/**
 * A button component that opens an enquiry form modal.
 * PLEASE replace it's usages with ToggleEnquiryFormButtonAura instead.
 * There is a lot of styles and overrides passed to this component in many locations.
 * This is why replacing it without thorough testing is tricky. If you work on some of these locations,
 * please replace it with ToggleEnquiryFormButtonAura instead.
 * @deprecated
 */

const ToggleEnquiryFormButton = ({
  noIcon = false,
  size = 'normal',
  fixedWidth,
  styleWrapper = {},
  styleButton = {},
  contactMethod,
}: IProps) => {
  const { t } = useTranslation();
  const isVenue = useSelector(getIsVenue);
  const enquiryCTAText = useMemo(
    () => (isVenue ? t('common:cta.requestBrochure') : t('common:enquiryCTA.nonVenue')),
    [isVenue, t],
  );

  return (
    <ToggleEnquiryFormWithSignup contactMethod={contactMethod}>
      <ButtonComp
        fixedWidth={fixedWidth}
        noIcon={noIcon}
        size={size}
        styleWrapper={styleWrapper}
        styleButton={styleButton}>
        {enquiryCTAText}
      </ButtonComp>
    </ToggleEnquiryFormWithSignup>
  );
};

export default memo(ToggleEnquiryFormButton);
